import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { createTheme, MantineProvider } from "@mantine/core";

import App from "./App";
import "./index.css";

import RouteScroll from "./components/common/RouteScroll";

// 접근성/AEO 안전장치: SweetAlert2 등 라이브러리가 동적으로 삽입하는
// <img> 에도 alt 가 비지 않도록 보장한다. (모달 이미지는 기본적으로
// src 없이 숨겨져 있지만, alt 누락으로 잡히지 않도록 방어적으로 채운다.)
if (typeof window !== "undefined" && typeof MutationObserver !== "undefined") {
  const ensureAlt = (img: HTMLImageElement) => {
    if (!img.getAttribute("alt")) img.setAttribute("alt", "스마트장인누수 알림 이미지");
  };
  document.querySelectorAll("img").forEach((img) => ensureAlt(img as HTMLImageElement));
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          if (node.tagName === "IMG") ensureAlt(node as HTMLImageElement);
          node.querySelectorAll?.("img").forEach((img) => ensureAlt(img as HTMLImageElement));
        }
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const theme = createTheme({
  /** Put your mantine theme override here */
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteScroll />
      <MantineProvider theme={theme}>
        <App />
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
